// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { miniCartStyles } from "@steiner/App/Components/MiniCart/MiniCart";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, styledScrollbar, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const sharedTitleText: TypographyPresentationProps = {
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-right: 4px;
    `,
};

const sharedValueText: TypographyPresentationProps = {
    size: 16,
    lineHeight: "26px",
    weight: fontConfig.weight.semiBold,
};

miniCartStyles.cartHeaderWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding: 12px;
        border-bottom: 1px solid ${color("common.border")};
        min-width: 460px;
    `,
};

miniCartStyles.subTotalTitle = {
    ...sharedTitleText,
};

miniCartStyles.subTotalValue = {
    ...sharedValueText,
};

miniCartStyles.totalCountTitle = {
    ...sharedTitleText,
};

miniCartStyles.totalCountValue = {
    ...sharedValueText,
};

miniCartStyles.cartFooterWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding: 12px;
        background: ${color("common.ui2")};
        box-shadow: 0 -1px 0 0 ${color("common.ui3")};
        gap: 8px;
    `,
};

miniCartStyles.viewCartButton = {
    variant: "secondary",
};

miniCartStyles.cartLinesWrapper = {
    css: css`
        max-height: 555px;
        padding: 12px 12px 0;

        ${styledScrollbar()}

        // Allowing 6 items in view
        ${xScreen("gt", 1800)} {
            max-height: 675px;
        }
    `,
};

miniCartStyles.errorMessagesContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 12px;
    `,
};

miniCartStyles.errorMessageNotification = {
    css: css`
        margin: 0;
    `,
};

miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 12px;
        min-width: 120px;
    `,
};
